import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Tooltip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    tooltip: {
        '&.MuiTooltip-tooltip': {
            backgroundColor: theme.palette.background.default,
            background: theme.palette.background.default,
            opacity: 1,
        },
    },
    typography: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        width: 'max-content',
        display: 'block',
    },
}));

const TruncatedText = ({
    text,
    variant,
    color,
    fw,
    fs,
    sx,
    textAlign,
    tooltipPlacement,
    className,
}) => {
    const classes = useStyles();

    const textRef = useRef(null);
    const [isOverflowed, setIsOverflowed] = useState(false);

    useLayoutEffect(() => {
        const checkOverflow = () => {
            if (textRef.current) {
                setIsOverflowed(
                    textRef.current.scrollWidth > textRef.current.clientWidth
                );
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [text, textRef.current]);

    return (
        <Tooltip
            arrow
            className={classes.tooltip}
            placement={tooltipPlacement}
            title={isOverflowed ? text : ''}
        >
            <Typography
                noWrap
                ref={textRef}
                className={clsx(classes.typography, className)}
                color={color}
                variant={variant}
                fontSize={fs}
                fontWeight={fw}
                textAlign={textAlign}
                sx={sx}
            >
                {text}
            </Typography>
        </Tooltip>
    );
};

TruncatedText.defaultProps = {
    text: '-',
    className: '',
    variant: 'body2',
    tooltipPlacement: 'top',
};

TruncatedText.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fw: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    variant: PropTypes.string,
    className: PropTypes.string,
    tooltipPlacement: PropTypes.string,
};

export default TruncatedText;
